module.exports = __webpack_public_path__ + "img/enquiry2.f137dc2d.svg";